import React, {useState} from "react";
import {FaRegTimesCircle} from "react-icons/fa";
// import {GrPowerReset} from "react-icons/gr";
// import {AiOutlineReload} from "react-icons/ai";
import {FiRotateCw} from "react-icons/fi";
// import {RiSettings3Fill} from "react-icons/ri";
// import {RiArrowGoBackFill} from "react-icons/ri";
import {IoMdArrowRoundBack} from "react-icons/io";
import {Link} from "react-router-dom";


import styled from "styled-components";

// import 'bootstrap/dist/css/bootstrap.min.css';

const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  // flex-direction: row;
  // height: 100%;
`;

const Score = styled.div`
  flex: 0.40;
  background: #3b6653;
  margin: 5px;
  display: flex;
  align-items: center;
  /* height: 100%; */
  /* width: 100%; */
  justify-content: center;
  border-radius: 5px;
  border: 1.5px solid black;
  position: relative;
`;

const ScoreValue = styled.p`
  font-size: 1.5em;
  font-weight: bold;
  color: yellow;
  font-family: Shrikhand;
  //random
`;

const ScoreTitle = styled.span`
  font-size: 11px;
  color: yellow;
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-family: Shrikhand;
`;

const Pause = styled.button`
  flex: 0.20;
  background-color: rgba(211, 61, 37, 0.8);
  margin: 5px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  justify-content: center;
`;

const GameHeader3 = ({levelNumber = 1, playAgain = null}) => {

  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const openSettings = () => {
    console.log("lol")
    // setDropTime(900000)
    // setIsSettingsOpen(true);
  };


  const closeSettings = () => {
    setIsSettingsOpen(false);
  };
  return (
    <>
      <Container>
        <Back to="/" >
          <SettingsIcon />
        </Back>
        <Title>Level {levelNumber}</Title>
        {/* <Back to="/play-offline" > */}
        <ResetIcon onClick={playAgain} />
        {/* </Back> */}
      </Container>
    </>
  );
};

export default React.memo(GameHeader3);


const SoundContainer = styled.button`
  padding: 10px;
  border-radius: 5px;
  /* display: flex; */
  /* justify-content: space-evenly; */
  /* flex-direction: row; */
  margin-bottom: 5px;
  font-weight: bolder;
  width: 70vw;
  border: 0.5px solid white;
  font-weight: bolder;

`
const CloseButton = styled(FaRegTimesCircle)`
  /* background-color: red; */
  position: absolute;
  right:-2%;
  top:-3%;
`

const ModalOverlay = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(0, 0, 0, 0.5); //semi-transparent background
/* background-color: rgb(13,22,29); */

/* background: black; */
display: flex;
justify-content: center;
align-items: center;
z-index: 1000; /* Ensure it's on top of other elements */

`;

const SettingsPopupContainer = styled.div`
background: white;
padding: 20px;
border-radius: 8px;
background-color: black;

background: #001f3f;
border-radius: 20px;
width: 50vh;
height: 50vh;
opacity: 1;
position: relative;

@media (max-width: 767px) {
      width: 70vw;
      height: 40vw;
  }
`;
const PopupTitle = styled.h2`
  font-size: 5vw;
  font-family: Shrikhand;
  position: relative;
`;

const ResetIcon = styled(FiRotateCw)`
  position: absolute;
  top: 20px;
  right: 25px;
  font-size: 28px;
  color: ${({theme}) => theme.colors.textColor1};
  cursor: pointer;
  stroke-width: 3px;
//   background-color: red;
//   padding-right: 20px;
`;

const SettingsIcon = styled(IoMdArrowRoundBack)`
  position: absolute;
  top: 20px;
  left: 25px;
  font-size: 30px;
  color: ${({theme}) => theme.colors.textColor1};
  cursor: pointer;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  color: ${({theme}) => theme.colors.textColor1};
  font-family: Shrikhand;
      font-family: text4;
      // pading-bottom: 20px;

  // position: relative;
`;

const Back = styled(Link)`

`;